import { useQuery } from "@tanstack/react-query";
import {
  getDashboard,
  getDashboardStats,
  DashboardData,
  DashboardStats,
} from "@/api";

/**
 * Hook to fetch complete dashboard data
 */
export const useDashboard = () => {
  return useQuery<DashboardData>({
    queryKey: ["dashboard"],
    queryFn: getDashboard,
    staleTime: 60 * 1000, // 1 minute
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  });
};

/**
 * Hook to fetch just dashboard stats (lighter request)
 */
export const useDashboardStats = () => {
  return useQuery<DashboardStats>({
    queryKey: ["dashboard", "stats"],
    queryFn: getDashboardStats,
    staleTime: 60 * 1000,
    refetchInterval: 2 * 60 * 1000, // Refetch every 2 minutes
  });
};
